<div class="content">
  <div class="resource">
    <a href="https://www.faa.gov/regulations_policies/handbooks_manuals/aviation/advanced_avionics_handbook/"
       target="_new">
      <h2>Advanced Avionics Handbook</h2>

      <p>
        This is designed to provide general aviation users with comprehensive information on
        advanced avionics equipment available in technically advanced aircraft. This handbook
        introduces the pilot to flight operations in aircraft with the latest integrated “glass
        cockpit” advanced avionics systems.
      </p>
    </a>
  </div>
  <div class="resource">
    <a href="https://www.faa.gov/regulations_policies/advisory_circulars/" target="_new">
      <h2>Advisory Circulars</h2>

      <p>
        Quickly search, read and download all current FAA Advisory Circulars.
      </p>
    </a>
  </div>
  <div class="resource">
    <a href="https://www.faa.gov/regulations_policies/handbooks_manuals/aviation/media/00-80T-80.pdf"
       target="_new">
      <h2>Aerodynamics for Naval Aviators</h2>

      <p>
        Aerodynamics for Naval Aviators is the traditional text (NAVWEPS 00-80T-80) for Navy pilots.
        Also used by the U.S. Air Force, it remains the definitive work on applied aerodynamics for
        pilots.
      </p>
    </a>
  </div>
  <div class="resource">
    <a href="https://www.faa.gov/air_traffic/publications/atpubs/aim_html/index.html" target="_new">
      <h2>Aeronautical Information Manual (AIM)</h2>

      <p>
        Download the latest PDF version of the current Aeronautical Information Manual directly from
        the FAA.
      </p>
    </a>
  </div>
  <div class="resource">
    <a href="https://www.faa.gov/training_testing/testing/acs/" target="_new">
      <h2>Airman Certification Standards (ACS)</h2>

      <p>
        Download the latest PDF versions of the current Airman Certification Standards (ACS)
        directly from the FAA.
      </p>
    </a>
  </div>
  <div class="resource">
    <a href="https://www.faa.gov/regulations_policies/handbooks_manuals/aviation/airplane_handbook/"
       target="_new">
      <h2>Airplane Flying Handbook</h2>

      <p>
        The Airplane Flying Handbook provides basic knowledge that is essential for pilots. This
        handbook introduces basic pilot skills and knowledge that are essential for piloting
        airplanes.
      </p>
    </a>
  </div>
  <div class="resource">
    <a href="https://www.faa.gov/regulations_policies/handbooks_manuals/aviation/media/airship_pilot_manual.pdf"
       target="_new">
      <h2>Airship Pilot Manual</h2>

      <p>
        This Goodyear-issued official U.S. Navy Pilot’s Manual is a reproduction of an original
        issued in 1942. It discusses the airship and its flight controls, the envelope pressure
        control system, power plant and electrical system, and more.
      </p>
    </a>
  </div>
  <div class="resource">
    <a href="https://www.faa.gov/regulations_policies/handbooks_manuals/aviation/aviation_instructors_handbook/"
       target="_new">
      <h2>Aviation Instructor's Handbook</h2>

      <p>
        Designed for ground instructors, flight instructors, and aviation maintenance instructors,
        the Aviation Instructor’s Handbook was developed by the Flight Standards Service, Airman
        Testing Standards Branch, in cooperation with aviation educators and industry to help
        beginning instructors understand and apply the fundamentals of instruction.
      </p>
    </a>
  </div>
  <div class="resource">
    <a href="https://www.faa.gov/regulations_policies/handbooks_manuals/aircraft/media/FAA-H-8083-11.pdf"
       target="_new">
      <h2>Balloon Flying Handbook</h2>

      <p>
        This Balloon Flying Handbook introduces the basic pilot knowledge and skills that are
        essential for piloting balloons.
      </p>
    </a>
  </div>
  <div class="resource">
    <a href="https://www.faa.gov/pilots/testing/" target="_new">
      <h2>FAA Knowledge Testing Guides</h2>

      <p>
        Download the Airman Knowledge Test Guides, which include all the figures and legends
        required to answer questions on the pilot knowledge tests.
      </p>
    </a>
  </div>
  <div class="resource">
    <a href="https://www.faa.gov/pilots/regs/" target="_new">
      <h2>Federal Aviation Regulations (FAR)</h2>

      <p>
        View the entire set of Federal Aviation Regulations here organized by section.
      </p>
    </a>
  </div>
  <div class="resource">
    <a href="https://www.faa.gov/regulations_policies/handbooks_manuals/aviation/media/FAA-H-8083-18.pdf"
       target="_new">
      <h2>Flight Navigator Handbook</h2>

      <p>
        Provides information on all phases of air navigation. It is a source of reference for
        navigators and navigator students. This handbook explains how to measure, chart the earth,
        and use ight instruments to solve basic navigation problems.
      </p>
    </a>
  </div>
  <div class="resource">
    <a href="https://www.faasafety.gov/files/gslac/courses/content/33/346/GA%20Weather%20Decision-Making%20Aug06.pdf"
       target="_new">
      <h2>GA Pilot’s Guide to Preflight Weather Planning</h2>

      <p>
        This downloadable PDF is designed to guide pilots on the weather products to review during
        self-weather briefings and how to analyze this information to make an effective weather
        plan.
      </p>
    </a>
  </div>
  <div class="resource">
    <a href="https://www.faa.gov/regulations_policies/handbooks_manuals/aircraft/glider_handbook/"
       target="_new">
      <h2>Glider Flying Handbook</h2>

      <p>
        The Glider Flying Handbook is designed as a technical manual for applicants who are
        preparing for glider category rating and for currently certi cated glider pilots who wish to
        improve their knowledge.
      </p>
    </a>
  </div>
  <div class="resource">
    <a href="https://www.faa.gov/regulations_policies/handbooks_manuals/aviation/helicopter_flying_handbook/"
       target="_new">
      <h2>Helicopter Flying Handbook</h2>

      <p>
        The Helicopter Flying Handbook is designed as a technical manual for applicants who are
        preparing for their private, commercial, or flight instructor pilot certificates with a
        helicopter class rating.
      </p>
    </a>
  </div>
  <div class="resource">
    <a href="https://www.faa.gov/regulations_policies/handbooks_manuals/aviation/media/FAA-H-8083-15B.pdf"
       target="_new">
      <h2>Instrument Flying Handbook</h2>

      <p>
        This Instrument Flying Handbook is designed for use by instrument ight instructors and
        pilots preparing for instrument rating tests.
      </p>
    </a>
  </div>
  <div class="resource">
    <a href="https://www.faa.gov/regulations_policies/handbooks_manuals/aviation/instrument_procedures_handbook/"
       target="_new">
      <h2>Instrument Procedures Handbook</h2>

      <p>
        This is designed as a technical reference for all pilots who operate under instrument flight
        rules (IFR) in the National Airspace System (NAS).
      </p>
    </a>
  </div>
  <div class="resource">
    <a href="https://www.faa.gov/regulations_policies/handbooks_manuals/aviation/media/tips_on_mountain_flying.pdf"
       target="_new">
      <h2>Mountain Flying</h2>

      <p>
        Mountain flying opens up new opportunities for the general aviation pilot for unique and
        interesting destinations. Learn valuable tips for doing it safely in this guide.
      </p>
    </a>
  </div>
  <div class="resource">
    <a href="https://www.faa.gov/air_traffic/publications/media/PCG_10-12-17.pdf" target="_new">
      <h2>Pilot Controller Glossary</h2>

      <p>
        This Glossary was compiled to promote a common understanding of the terms used in the Air
        Traffic Control system. It includes those terms which are intended for pilot/controller
        communications.
      </p>
    </a>
  </div>
  <div class="resource">
    <a href="https://www.faa.gov/regulations_policies/handbooks_manuals/aviation/phak/" target="_new">
      <h2>Pilot's Handbook of Aeronautical Knowledge</h2>

      <p>
        The Pilot’s Handbook of Aeronautical Knowledge provides basic knowledge that is essential
        for pilots. This handbook introduces pilots to the broad spectrum of knowledge that will be
        needed as they progress in their pilot training.
      </p>
    </a>
  </div>
  <div class="resource">
    <a href="https://www.faa.gov/training_testing/testing/test_standards/" target="_new">
      <h2>Practical Test Standards (PTS)</h2>

      <p>
        Download the latest PDF versions of all the current Practical Test Standards (PTS) directly
        from the FAA.
      </p>
    </a>
  </div>
  <div class="resource">
    <a href="https://www.faa.gov/pilots/safety/" target="_new">
      <h2>Pilot Safety</h2>

      <p>
        Access the latest FAA Safety content, including NOTAMs, TFRs, Aviation News, information on
        the WINGS program and much more.
      </p>
    </a>
  </div>
  <div class="resource">
    <a href="https://www.faa.gov/regulations_policies/handbooks_manuals/aviation/media/remote_pilot_study_guide.pdf"
       target="_new">
      <h2>Remote Pilot Small Unmanned Aircraft Systems Study Guide</h2>

      <p>
        The Federal Aviation Administration (FAA) has published the Remote Pilot – Small Unmanned
        Aircraft Systems (sUAS) Study Guide to communicate the knowledge areas you need to study to
        prepare to take the Remote Pilot Certificate with an sUAS rating airman knowledge test.
      </p>
    </a>
  </div>
  <div class="resource">
    <a href="https://www.faa.gov/regulations_policies/handbooks_manuals/aviation/seaplane_handbook/"
       target="_new">
      <h2>Seaplane, Skiplane, and Float/Ski Equipped Helicopter Operations Handbook</h2>

      <p>
        This operational handbook introduces the basic skills necessary for piloting seaplanes,
        skiplanes, and helicopters equipped with floats or skis.
      </p>
    </a>
  </div>
  <div class="resource">
    <a href="https://www.faa.gov/regulations_policies/handbooks_manuals/aviation/media/FAA-H-8083-1.pdf"
       target="_new">
      <h2>Weight and Balance Handbook</h2>

      <p>
        The objective of this handbook is twofold: to provide the airframe and powerplant mechanic
        (A&P) with the method of determining the empty weight and empty weight center of gravity
        (EWCG) of an aircraft and to furnish the flight crew with information on loading and
        operating the aircraft to ensure its weight is within the allowable limit and the center of
        gravity (CG) is within the allowable range.
      </p>
    </a>
  </div>
</div>
